// @ts-strict-ignore
// ts strict causes a bunch of errors in banner header comp and ref
import { Injectable } from '@angular/core';
import { LMBreadcrumbsByCategory } from '@app/utils';

interface LMAboutBreadcrumbItem {
  type: 'FORM' | 'LIST' | 'PAGE' | 'AUDIT' | 'SYSTEM';
  busClass: string;
  specName: string;
  userFolder?: string;
}
export interface LMBreadcrumbItem extends LMAboutBreadcrumbItem{
  id: string | undefined;
  category?: string;
  title: string;
  routeUrl: string;
  // disabled: boolean;
  // current: boolean;
  callback?: SohoBreadcrumbItemCallbackFunction;
}
type LMAboutBreadcrumbs = { [id: string]: LMAboutBreadcrumbItem };
// type LMBreadcrumbsByCategory = { [category: string]: Array<SohoBreadcrumbItemOptions> };
@Injectable()
export class LMBreadcrumbService {
  private aboutBreadcrumbs:LMAboutBreadcrumbs = {};
  private m_breadcrumbs: Array<SohoBreadcrumbItemOptions> = [];
  private m_allBreadcrumbs: LMBreadcrumbsByCategory = {};
  private currentCategory = 'DEFAULT';

  public get breadcrumbs(): Array<SohoBreadcrumbItemOptions> {
    return this.m_breadcrumbs;
  }
  public get category(): string {
    return this.currentCategory;
  }

  public get allBreadcrumbs(): LMBreadcrumbsByCategory {
    return this.m_allBreadcrumbs;
  }

  public initialize(category: string, allBreadcrumbs: LMBreadcrumbsByCategory) {
    this.m_allBreadcrumbs = allBreadcrumbs;
    this.setCurrentCategory(category);
  }

  private setCurrentCategory(category: string) {
    this.currentCategory = (category) ? category : this.currentCategory ? this.currentCategory : 'DEFAULT';

    if (!this.m_allBreadcrumbs.hasOwnProperty(this.currentCategory)) {
      this.m_allBreadcrumbs[this.currentCategory] = [];
    }
    this.m_breadcrumbs = this.m_allBreadcrumbs[this.currentCategory];
  }

  public addBreadcrumbItem(bcItem: LMBreadcrumbItem): string {
    this.setCurrentCategory(bcItem.category);

    let itemTitle = bcItem.title.trim();
    if (bcItem.routeUrl.length > 0 && itemTitle.length === 0) {
      // The component may have a blank title. Add the spec name as title for now.
      itemTitle = bcItem.specName;
    }
    // 1. Check if the item exists in bread crumbs based on id.
    if (bcItem.id) {
      const index = this.m_breadcrumbs.findIndex(b => b.id === bcItem.id);
      if (index > -1) {
        this.spliceItems(index);
        // The item may have a new url or title say, from form paging
        const bc: SohoBreadcrumbItemOptions = { id: bcItem.id, content: itemTitle, href: bcItem.routeUrl };
        this.m_breadcrumbs[index] = bc;
        return bcItem.id;
      }
    }

    // 2. If not, check if there is one that matches specName
    // const key = Object.keys(this.aboutBreadcrumbs).find(k => this.specMatch(this.aboutBreadcrumbs[k], bcItem));
    // if (key) {
    //   this.updateBreadcrumbItem(key, bcItem);
    //   return this.setCurrent(key);
    // }

    // 3. Else, add the breadcrumb
    const id = Math.random().toString(10);

    const bc: SohoBreadcrumbItemOptions = { id, content: itemTitle, href: bcItem.routeUrl };
    if (bcItem.callback) {
      bc.callback = bcItem.callback;
    }
    this.m_breadcrumbs[ this.m_breadcrumbs.length] = bc;
    this.aboutBreadcrumbs[id] = { type: bcItem.type, busClass: bcItem.busClass, specName: bcItem.specName, userFolder: bcItem.userFolder };
    return id;
  }

  private setCurrent(id: string): string {
    this.m_breadcrumbs.forEach(b => b.current = (b.id === id));
    return id;
  }

  private specMatch(aboutBC: LMAboutBreadcrumbItem, bcItem: LMBreadcrumbItem) :boolean {
    return aboutBC.type === bcItem.type && aboutBC.busClass === bcItem.busClass && aboutBC.specName === bcItem.specName && aboutBC.userFolder === bcItem.userFolder;
  }
  private updateBreadcrumbItem(id: string, bcItem: LMBreadcrumbItem) {
    const index = this.m_breadcrumbs.findIndex(b => b.id === id);
    if (index > -1) {
      const sohoBreadcrumb: SohoBreadcrumbItemOptions = { id, content: bcItem.title, href: bcItem.routeUrl,
        current: true, disabled: false, callback: bcItem.callback };
      this.m_breadcrumbs.splice(index, 1, sohoBreadcrumb);
      // Trim the rest
      this.spliceItems(index);
    }
  }

  public deleteBreadcrumbItem(id: string)  {
    const index = this.m_breadcrumbs.findIndex(b => b.id === id);
    if (index > -1) {
      this.m_breadcrumbs.splice(index, 1);
      delete this.aboutBreadcrumbs[id];
    }
    return;
  }

  /**
   * Reset will be called when a user clicks on a top level menu item or home page or web app switcher or search results
   * @param category
   */
  public reset(category?: string): Array<SohoBreadcrumbItemOptions> {
    this.setCurrentCategory(category);
    this.removeAboutItems(this.m_breadcrumbs);
    this.m_allBreadcrumbs[this.currentCategory] = [];
    this.m_breadcrumbs = [];
    return this.m_breadcrumbs;
  }

  private removeAboutItems(bcs: SohoBreadcrumbItemOptions[]) {
    bcs.forEach(bcItem => {
      if (bcItem?.id) {
        delete this.aboutBreadcrumbs[ bcItem.id ];
      }
    });
  }
  public spliceItems(index: number) {
    const removedItems = this.m_breadcrumbs.splice(index + 1, this.m_breadcrumbs.length - index - 1);
    this.removeAboutItems(removedItems);
  }
}
